import React, {Component, Fragment} from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from "react-redux";
import './benefit_page.scss';
import {
    acquireCoupon,
    acquireCouponWeb,
    addPopup,
    getAvailabaleCoupons,
    getBenefitById,
    removePopup,
    setAvailableCoupon,
    setBenefitPage,
    setDynamicLink,
    setLegalWaiverAgreement,
    setUserLegalWaiverAgreements,
} from "../../redux/actions";
import * as Popups from '../../constants/popup-types';
import * as routes from '../../constants/routes';
import { getCategoryBreadcrumbRoute } from '../hot_yoter/utils/hotYoterCategoryRoute';
import AnalyticsManager from '../../app/analytics';
import {cleanUpObject, createAnalyticsItemsList, getMediaPath, reactParserCommonOptions} from '../../app/functions';
import {UpsalePopupStatus, SendPlatform, SHARE_CONTENT_SOURCE, ShareAnalyticsMethod} from '../../app/enums';

import ReactHtmlParser from 'react-html-parser';

//components
import Timer from "../shared/timer/timer";
import Collapse from "../../components/common/collapse";
import BenefitsSlider from '../../containers/shared/benefits-slider/benefits-slider';
import BreadCrumbs from '../../components/common/bread_crumbs';
import BranchesMap from '../shared/branches-map';
import FavoriteButton from '../shared/favorite-btn';

//assets
import plus from 'assets/icons/arrow_down.svg';
import shareBenefitIcon from 'assets/icons/sharebenefit.svg';
import Loader from "../../components/common/loader";
import LeadPage from "../lead_page";
import ImageCarousel from "../../components/image-carousel";
import LeadForm from './sections/lead-form';
import lockBlueIconPath from '../../assets/icons/lock-white-icon.svg';
import {EmarsysManager} from 'app/emarsys';
import {searchApi} from "../../redux/api/search.api";
import {CONTAINER_ID} from "../../app/emarsys/constants";
import BenefitsSliderNew from "../shared/benefits-slider-new/benefits-slider-new";
import ShareButton from 'containers/landing_join_content_page/components/ShareButton';
import theme from '../../theme';
import {
    shareViaNativeShare,
    copyToClipboard,
} from 'containers/landing_join_content_page/utils/utils';
import {BENEFIT_DEEP_LINK_BASE_URL} from 'pages/personal-zone/utils/constants';
import Checkbox from '../../components/forms/checkbox';
import cb_checked_mobile from '../../assets/icons/checkbox-checked-purple-mobile.svg';
import cb_checked from '../../assets/icons/checkbox-check-purple.svg';
import cb from '../../assets/icons/checkbox-purple.svg';


class BenefitPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            big_screen_url: false,
            big_screen_type: false,
            selected_img: 0,
            selected_collapse: -1,
            addition_data_open: false,
            input: {val: 0, first_try: true},
            preview_link: false,
            selected_nav_tab: 0,
            waiverOpen: false,
            waiverStatement: false,
            leadFormVisible: false,
            recommendedBenefits: null,
            recommendedPersonalBenefits: null,
            isLoggedIn: !!props.userData,
            isClickedBuy: false,
            hasShownEligibilityPopup: false,
            shareToastOpen: false,
            couponReminderCheckbox: false,
        };

        this.leadFormRef = React.createRef(null);
        this.onClick = React.createRef(null);

        this.getExtraData = this.getExtraData.bind(this);
        this.cityOnChange = this.cityOnChange.bind(this);
        this.handleCollapseOnClick = this.handleCollapseOnClick.bind(this);
        this.handleSendLink = this.handleSendLink.bind(this);
    }

    async getEmarsysRecommendedBenefits(ids) {
        const filteredIds = ids.filter(id => id !== this.props.benefit.id)
        if (!filteredIds.length) return []
        const result = await this.props.getSelectedBenefits({
            ids: filteredIds
        }).catch(() => ([]))

        const benefits = Array.isArray(result.data) ? result.data : []
        return benefits.map(b => ({...b, maRecommended: true}))

    }

    showRecommendations() {
        if (!window.showEmarsysRecommendations)
            return

        if (window.allowRelatedRecommendation && this.props.parameters.enable_ma_related_recommendations)
            EmarsysManager.emarsysRelatedRecommendation(this.props.match.params.id)
                .then((formatted) => {
                    if (formatted?.benefits) {
                        this.getEmarsysRecommendedBenefits(formatted.benefits.map(benefit => benefit.id))
                            .then((benefits) => {
                                this.setState({recommendedBenefits: {...formatted, benefits}});
                            })
                    }
                })

        if (this.props.parameters.enable_ma_personal_recommendations && this.props.userData)
            EmarsysManager.emarsysPersonalRecommendation()
                .then((formatted) => {
                    if (formatted?.benefits) {
                        this.getEmarsysRecommendedBenefits(formatted.benefits.map(benefit => benefit.id))
                            .then((benefits) => {
                                this.setState({recommendedPersonalBenefits: {...formatted, benefits}});
                            })
                    }
                });
    }

    componentDidMount() {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        if (urlParams.has('preview_link')) {
            var preview = urlParams.get('preview_link');
            this.props.getBenefitById({benefitId: this.props.match.params.id, preview_link: preview, isCommerce: 0});
            this.setState({preview_link: true});
        } else {
            this.props.getBenefitById({benefitId: this.props.match.params.id, isCommerce: 0});
        }

        document.body.classList.add('benefitPageBody');
        this.showRecommendations()
    }

    componentWillUnmount() {
        this.props.setBenefitPage(false);
        this.props.setAvailableCoupon(false);
        this.props.resetDynamicLink();
        document.body.classList.remove('benefitPageBody');
        this.setState({leadFormVisible: false});

    }

    componentDidUpdate(nextProps) {
        if (this.props.match.params.id !== nextProps.match.params.id) {
            this.props.getBenefitById({benefitId: this.props.match.params.id, isCommerce: 0});
            this.showRecommendations()
        }
        //refers to non-paid coupon
        else if (this.props.acquired !== nextProps.acquired) {
            this.props.addPopup({
                type: Popups.ACQUIRED,
                benefitId: this.props.match.params.id,
                isAcquired: false,
                purchased: false,
            })
        }
        //refers to paid coupon
        else if (this.props.purchased !== nextProps.purchased && this.props.purchased) {
            this.props.addPopup({
                type: Popups.ACQUIRED,
                benefitId: this.props.match.params.id,
                isAcquired: false,
                purchased: true,
                action: () => this.handleAfterPurchase()
            })
        } else if (this.props.availableCoupon !== nextProps.availableCoupon) {
            if (!nextProps.availableCoupon) {
                if (parseInt(this.props.availableCoupon.available_coupons) > 0) {
                    this.props.removePopup();
                    this.props.addPopup({
                        type: Popups.PAYMENT,
                        benefitId: this.props.match.params.id,
                        benefitType: this.props.benefit?.main?.benefit_type,
                        screenHeight: window.innerHeight
                    });
                } else {
                    this.props.addPopup({
                        type: Popups.GENERAL_MESSAGE,
                        text: this.props.text['payment_coupon_ended']
                    })
                }
            }
        } else if (this.props.benefit !== nextProps.benefit) {
            if (this.props.benefit && this.props.benefit !== 'error') {
                AnalyticsManager.logViewItem(createAnalyticsItemsList([this.props.benefit]));

                this.setState({leadFormVisible: false})
                this.setState({big_screen_type: this.props.benefit.main.images[0].type});
                
                // Check user eligibility when benefit data is loaded
                const isUserEligible = this.props.benefit.main?.userEligibility?.isUserEligible;
                if (isUserEligible === false && !this.state.hasShownEligibilityPopup) {
                    this.setState({hasShownEligibilityPopup: true}, () => {
                        const redirectToHome = () => {
                            this.props.history.push(routes.home);
                        };
                        
                        this.props.addPopup({
                            type: Popups.GENERAL_MESSAGE,
                            text: this.props.benefit.main.userEligibility?.errorMessage ? ReactHtmlParser(this.props.benefit.main.userEligibility?.errorMessage) : 'לקוח לא זכאי',
                            action: redirectToHome, 
                            onClose: redirectToHome,
                            btnText: this.props.text['web_return_to_home'],
                        });
                    });
                }
            }
            if (this.props.benefit === 'error') {
                this.props.history.push(routes.home);
            }
        }
    }

    handleAfterPurchase() {
        this.props.history.push(routes.home);
    }

    handleCollapseOnClick(id) {
        if (id === this.state.selected_collapse)
            id = -1;
        this.setState({selected_collapse: id})
    }

    getExtraData() {
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        const data = this.props.benefit.information;

        let res = [];

        if (isLaptopOrDesktop) {

            if (data.length > 0) {
                res.push(
                    <div key={'y10010101'} className='navbar'>
                        {data.map((item, index) => {
                            return <span key={index}
                                         className={'nav-op ' + (this.state.selected_nav_tab === index ? 'selected' : '')}
                                         onClick={() => {
                                             this.setState({selected_nav_tab: index})
                                         }}>{item.title}</span>
                        })}
                    </div>
                );

                res.push(
                    <div key={'z10010101'} className='details-wrapper'>
                        {data.map((item, index) => (
                            <div key={index} className='content' style={{display: this.state.selected_nav_tab === index ? 'flex' : 'none'}}>
                                {ReactHtmlParser(item.content, reactParserCommonOptions())}
                            </div>
                        ))}
                    </div>
                );
            }
        } else {
            data.forEach((item, index) => {
                res.push(
                    <Collapse key={index}
                              id={index}
                              className={'details-collapse'}
                              label={item.title}
                              custom_arrow={getMediaPath(plus)}
                              handleCollapseState={this.handleCollapseOnClick}
                              open={this.state.selected_collapse === index}>
                        {ReactHtmlParser(item.content, reactParserCommonOptions())}
                    </Collapse>
                )
            });
        }

        return res;
    }

    cityOnChange(id) {
        this.setState({city: {...this.state.city, selected: id}});
    }

    handleSendLink() {
        AnalyticsManager.logAddToCart(createAnalyticsItemsList([this.props.benefit]));
        AnalyticsManager.logBenefitWebsiteOpen(this.props.benefit?.main?.id, this.props.benefit?.main?.title);

        //fb pixel action
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'ViewContent');
        }

        //send button has different behaviours according to device and external link definition
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        const default_send_behaviour = !this.props.benefit.main.url;
        const vipBenefit = this.props.benefit.main.vipBenefit;

        if (default_send_behaviour) {
            if (!isLaptopOrDesktop) {
                window.open(this.props.benefit.main.app_link, '_blank', 'noopener norefferer');
            } else {
                this.props.addPopup({type: Popups.APP_DOWNLOAD});
            }
        } else {
            if (vipBenefit) {
                if (this.props.benefitStatusDown) {
                    window.open(this.props.benefit.main.url.route, 'noopener norefferer');
                } else {
                    this.props.addPopup({type: Popups.MEMBERSHIP_CHECK, benefitId: this.props.match.params.id});
                }
            } else {
                window.open(this.props.benefit.main.url.route, 'noopener norefferer');
            }
        }
    }

    handleFavClick = () => {
        this.setState({is_loved: !this.state.is_loved});
    };

    handleShareButtonClick = async () => {
        const shareUrl = this.props.benefit.main.dynamicLink;
        const shareTitle = this.props.text?.share_benefit_title_text || this.props.benefit?.main?.benefit_name || this.props.benefit?.main?.title || '';
        const canShare = !!navigator.share;
        const text = shareTitle ? `${this.props.text?.share_benefit_content_text || ''} ${'\n'}${shareUrl}` : shareUrl;

        if (canShare) {
            const shared = await shareViaNativeShare(shareUrl, text, shareTitle);
            AnalyticsManager.logShareUrl(SHARE_CONTENT_SOURCE.BENEFIT_PAGE, ShareAnalyticsMethod.SHARE, shareUrl);
            if (!shared) {
                const success = await copyToClipboard(shareUrl);
                if (success) {
                    AnalyticsManager.logShareUrl(SHARE_CONTENT_SOURCE.BENEFIT_PAGE, ShareAnalyticsMethod.COPY_LINK, shareUrl);
                    this.setState({shareToastOpen: true});
                    setTimeout(() => this.setState({shareToastOpen: false}), 2000);
                }
            }
        } else {
            const success = await copyToClipboard(shareUrl);
            if (success) {
                AnalyticsManager.logShareUrl(SHARE_CONTENT_SOURCE.BENEFIT_PAGE, ShareAnalyticsMethod.COPY_LINK, shareUrl);
                this.setState({shareToastOpen: true});
                setTimeout(() => this.setState({shareToastOpen: false}), 2000);
            }
        }
    };

    getExtraInfo = () => {
        const information = this.props.benefit.main.information;

        let res = [];

        if (this.props.benefit.main.hasOwnProperty('information')) {
            information.forEach((item, index) => {
                res.push(
                    <div key={index} className='info-wrapper'>
                        <span className='title'>{item.title}</span>
                        <div className='description'>
                            {ReactHtmlParser(item.content, reactParserCommonOptions())}
                        </div>
                    </div>
                )
            });
        }
        return res;
    };

    handleCouponClick = () => {
        const {benefit, deviceState} = this.props;
        const isDesktopOrLaptop = deviceState === 'desktop' || deviceState === 'desktop-large';

        AnalyticsManager.logAddToCart(createAnalyticsItemsList([benefit]));
        AnalyticsManager.logBenefitGetCouponCodePress(benefit.main.id, benefit.main.title);

        if (isDesktopOrLaptop) {
            if (this.props.benefit.isAcquired) {
                this.props.addPopup({
                    type: Popups.ACQUIRED,
                    benefitId: this.props.match.params.id,
                    isAcquired: true,
                    purchased: false,
                });
            } else if (this.state.input.val.length === 4) {
                const acquirePayload = {
                    code: this.state.input.val,
                    benefitId: this.props.match.params.id,
                };
                if (this.props.benefit.displayCouponReminderCheckbox || this.props.benefit.main?.displayCouponReminderCheckbox) {
                    acquirePayload.couponReminderCheckbox = this.state.couponReminderCheckbox;
                }
                this.props.acquireCoupon(
                    acquirePayload,
                    this.props.benefit,
                    this.props.text,
                    this.props.handleClose
                );
            }
        } else {
            if (this.props.benefit.main.awaitingRestocking) {
                return;
            } else if (!this.props.benefit.isAcquired) {
                this.props.addPopup({
                    type: Popups.CARD_CHECK,
                    benefitId: this.props.match.params.id,
                    benefitType: parseInt(this.props.benefit.main.benefit_type)
                });
            } else {
                this.props.addPopup({
                    type: Popups.ACQUIRED,
                    benefitId: this.props.match.params.id,
                    isAcquired: true,
                    purchased: false,
                });
            }
        }
    };

    handleAllowedBenefit = () => {
        const { benefit } = this.props;
        const userEligibility = benefit?.main?.userEligibility;        
        if (userEligibility) { 
            if (!userEligibility?.isUserEligible) {
                this.props.addPopup({
                    type: Popups.GENERAL_MESSAGE,
                    text: userEligibility.errorMessage ? ReactHtmlParser(userEligibility?.errorMessage) : 'לקוח לא זכאי',
                });
                return false;
            }
        }
        return true;
    }
    handlePayCouponClick = () => {
        const {benefit, userData} = this.props;

        const benefitId = benefit.main.id;
        const benefitTitle = benefit.main.title;
        const benefitType = benefit.main.benefit_type;

        if (userData) {
            let cardsArr = userData.cardsArr;
            let card = cardsArr.find((card) => (card.active && card.default));

            if (card) {
                AnalyticsManager.logAddToCart(createAnalyticsItemsList([benefit]), benefit?.main?.price_after_discount);
                AnalyticsManager.logBenefitGetPaidCouponPress(benefitId, benefitTitle);


                this.props.addPopup({
                    type: Popups.NEW_PAYMENT,
                    benefit: benefit,
                    benefitId: benefitId,
                    title: benefit.main.benefit_name,
                    benefitType: benefitType,
                    image: getMediaPath(benefit?.main?.images?.[0]?.value)
                });
                // this.props.getAvailableCoupons({ benefitId });
            } else {
                AnalyticsManager.logBenefitGetPaidCouponPressWithoutCard(benefitId, benefitTitle);
                this.props.addPopup({
                    type: Popups.ADD_CREDIT_CARD_POPUP,
                    benefitId, benefitType,
                    action: () => this.handleGetAvailableCoupons(benefitId, benefitTitle),
                });
            }
        }
    }

    handleGetAvailableCoupons(benefitId, benefitTitle) {
        AnalyticsManager.logAddToCart(createAnalyticsItemsList([this.props.benefit]), this.props.benefit?.main?.price_after_discount);
        AnalyticsManager.logBenefitPaidCouponEditUserCard(benefitId, benefitTitle);
        this.props.getAvailableCoupons({benefitId});
    }

    handleLoadMoneyClick = () => {

        const user = this.props.userData;
        const isDesktopOrLaptop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        // in case the user is logged in
        if (user) {
            if (isDesktopOrLaptop) {
                //checking 4 digits validation
                if (this.state.input.val.length === 4 && !this.props.benefit.main.awaitingRestocking) {
                    const acquirePayload = {
                        code: this.state.input.val,
                        benefitId: this.props.match.params.id,
                    };
                    if (this.props.benefit.displayCouponReminderCheckbox || this.props.benefit.main?.displayCouponReminderCheckbox) {
                        acquirePayload.couponReminderCheckbox = this.state.couponReminderCheckbox;
                    }
                    this.props.acquireCoupon(
                        acquirePayload,
                        this.props.benefit,
                        this.props.text,
                        this.props.handleClose
                    );
                }
                //if this benefit is already acquired
                else if (this.props.benefit.isAcquired) {
                    this.props.addPopup({
                        type: Popups.ACQUIRED,
                        benefitId: this.props.match.params.id,
                        isAcquired: true,
                        purchased: false,
                    });
                } else {
                    this.setState({...this.state, input: {...this.state.input, first_try: false}});
                }
            } else {
                //if this benefit is already acquired
                if (this.props.benefit.isAcquired) {
                    this.props.addPopup({
                        type: Popups.ACQUIRED,
                        benefitId: this.props.match.params.id,
                        isAcquired: true,
                        purchased: false
                    });
                } else {
                    this.props.addPopup({
                        type: Popups.CARD_CHECK,
                        benefitId: this.props.match.params.id,
                        benefitType: parseInt(this.props.benefit.main.benefit_type)
                    });
                }
            }
        }
        //in case the user is logged out
        else {
            this.props.addPopup({
                type: Popups.LOGIN
            });
        }
    };

    handleDiscountClick = () => {
        const benefit = this.props.benefit;
        window.open(benefit.main.url.route, '_blank', 'noopener norefferer');
    };

    getButton = () => {
        if (this.state.leadFormVisible) return null;

        const {benefit, deviceState, text} = this.props;
        const {appHomeScreenDynamicLink} = this.props.parameters;
        const {
            is_data_sharing_consent_required: isDataSharingConsentRequired,
            is_marketing_consent_required: isMarketingConsentRequired,
            is_app_only: isAppOnly,
            dynamicLink,
        } = benefit.main;

        const isDesktopOrLaptop = deviceState === 'desktop' || deviceState === 'desktop-large';
        const isMobileOrTablet = deviceState === 'mobile' || deviceState === 'tablet';

        let isUrl = this.props.benefit.main.url;
        let benefit_type = parseInt(benefit.main.benefit_type);

        let isAcquired = benefit.isAcquired;
        const showCouponReminderCheckbox = benefit_type === 300 && !isAcquired && !benefit.main.awaitingRestocking && !isAppOnly && (benefit.displayCouponReminderCheckbox || benefit.main.displayCouponReminderCheckbox);

        let hoverMessage = null;
        let buttonText = benefit?.main?.btnText;

        if (benefit.main.awaitingRestocking && !benefit.isAcquired) {
            buttonText = text['out_of_stock_text'];
        }

        let className = '';
        let err_msg = '';

        switch (benefit_type) {
            case 100:
                if (isUrl) {
                    className = 'payment-position';
                    this.onClick.current = this.handleSendLink;
                } else {
                    className = 'disabled';
                }
                break;
            case 200:
                buttonText = text['smart_wallet_download_app_button'];
                this.onClick.current = () => {
                    AnalyticsManager.logAddToCart(createAnalyticsItemsList([benefit]));
                    if (isDesktopOrLaptop) {
                        this.props.addPopup({
                            type: Popups.IMAGE_POPUP,
                            image: {src: getMediaPath(this.props.appPopup.image), alt: this.props.text['mega_menu_hot_app']}
                        });
                    } else {
                        const benefitDeepLink = dynamicLink ?? `${BENEFIT_DEEP_LINK_BASE_URL}/${benefit.main.id}`;
                        window.open(benefitDeepLink, '_blank');
                    }
                };
                break;
            case 300:
                className = 'coupon';
                err_msg = this.props.acquiredErr ? this.props.acquiredErr.content : '';
                this.onClick.current = () => {
                    if (!this.handleAllowedBenefit()) return;
                    this.handleCouponClick();
                };
                break;
            case 700:
                this.onClick.current = this.handleNavigateToLink;
                break;
            case 800:
            case 1300:
                this.onClick.current = () => {
                    if (!this.handleAllowedBenefit()) return;
                    this.handlePayCouponClick();
                };
                if (benefit.isAcquired === null) {
                    className = 'coupon';
                    err_msg = this.props.availableCouponErr ? this.props.availableCouponErr.content : '';
                } else {
                    className = 'acquired';
                }
                break;
            case 1100:
                this.onClick.current = this.handleTravelInsurancePopup;
                break;
            case 1200:
                buttonText = benefit.leadsConfig?.submitButtonText || text['benefit_lead_form_toggle_button'];
                this.onClick.current = this.handleLeadFormClick;
                break;
            default:
                className = 'payment-position';
                this.onClick.current = this.handleSendLink;
                break;
        }

        if (isAppOnly) {
            this.onClick.current = () => {
                if (isDesktopOrLaptop) {
                    this.props.addPopup({
                        type: Popups.IMAGE_POPUP,
                        image: {
                            src: getMediaPath(this.props.appPopup.image),
                            alt: this.props.text['mega_menu_hot_app']
                        }
                    });
                } else {
                    window.open(dynamicLink ?? appHomeScreenDynamicLink, '_blank');
                }
            };
        }

        if (isAppOnly) {
            buttonText = (
                <>
                    <img src={lockBlueIconPath} alt="Blue Lock Icon" className="send-btn-icon"/>
                    {text['app_only_benefit_button']}
                </>
            );
            hoverMessage = text['app_only_benefit_message'];
        }

        const onButtonClick = () => {
            const {id, legal_waiver_statement, awaitingRestocking} = this.props.benefit.main;
            const {legalWaiversAgreements, consentedToDataSharing = []} = this.props.userData;

            if (legal_waiver_statement && this.props.userData) {
                if (!legalWaiversAgreements.includes(id) && !this.state.waiverStatement) {
                    const onAccept = () => {
                        this.setState({waiverStatement: true});
                        this.props.setLegalWaiverAgreement({benefit_id: id}, (data) => {
                            const {legalWaiversAgreements} = data;
                            this.props.setUserLegalWaiverAgreements(legalWaiversAgreements);
                        });
                        this.onClick.current();
                    };

                    this.props.addPopup({
                        type: Popups.WAIVER_AGREEMENT,
                        payload: {
                            onAccept: onAccept,
                            message: legal_waiver_statement,
                            checked: this.state.waiverStatement
                        }
                    });
                    return;
                }
            }

            if (awaitingRestocking && benefit.is_subsidized) {
                AnalyticsManager.logUpsalePopupPresented(UpsalePopupStatus.NO_INVENTORY);
            }
            if (awaitingRestocking && !benefit.isAcquired) {
                if (benefit.relatedBenefits) {
                    this.props.addPopup({
                        type: Popups.SUBSIDY_POPUP,
                        content: text['benefit_coupons_inventory_awaiting_restocking_message'],
                        header: benefit.main.title,
                        benefits: benefit.relatedBenefits,
                        status: UpsalePopupStatus.NO_INVENTORY,
                        footerText: benefit.main.upsell_popup_footer_text
                    })
                }else{
                    this.props.addPopup({
                        type: Popups.GENERAL_MESSAGE,
                        text: text['benefit_coupons_inventory_awaiting_restocking_message'],
                    });
                }
            }
            

            const checkAndOpenConsentsPopup = () => {
                const isMarketingApproved = (this.props.isMarketingApproved || !!this.props.userData.maStatus);
                const isSubsidyConsentApproved = this.props.userData.isUserApprovedSubsidy;
                const isSubsidyConsentRequired = benefit.is_subsidized;
                const isSubsidyLegalPopup = benefit.is_subsidized;
                let isShowSubsidyCheckbox = isSubsidyConsentRequired && !isSubsidyConsentApproved;
                const isShowMarketingCheckbox = (isMarketingConsentRequired || isShowSubsidyCheckbox) && !isMarketingApproved;
                let isShowDataSharingCheckbox = (isDataSharingConsentRequired || isShowSubsidyCheckbox) && !consentedToDataSharing;

                if (isShowDataSharingCheckbox || isShowMarketingCheckbox || isShowSubsidyCheckbox) {
                    if (isSubsidyLegalPopup){
                        this.props.addPopup({
                            type: Popups.DATA_SHARING_SUBSIDY_POPUP,
                            onAgreement: () => this.onClick.current?.(),
                            isShowMarketingCheckbox,
                            isShowDataSharingCheckbox,
                            isShowSubsidyCheckbox,
                            headerText: text['data_sharing_popup_header'],
                            benefitId: benefit?.main?.id,
                            subtitle: text['consents_subsidy_modal_content'],
                        });
                    }
                    else{
                        this.props.addPopup({
                            type: Popups.DATA_SHARING_POPUP,
                            onAgreement: () => this.onClick.current?.(),
                            isShowMarketingCheckbox,
                            isShowDataSharingCheckbox,
                            isShowSubsidyCheckbox,
                            headerText: text['data_sharing_popup_header'],
                            benefitId: benefit?.main?.id,
                            subtitle: ' ',
                        });
                    }
                } else {
                    this.onClick.current();
                }
            };

            checkAndOpenConsentsPopup();
        };

        if ((this.isUserLoggedInRequired() || benefit.main.linkRequiresLogin || isDataSharingConsentRequired) && !this.props.userData) {
            return (
                <div className={'send-wrapper ' + className}>
                    <button className={'send-btn '} onClick={this.goToLoginPage}>
                        {this.props.text['benefit_login_btn_text']}
                    </button>
                </div>
            );
        } else {
            if (!isDesktopOrLaptop && benefit.main.url) {
                return (
                    <div className={'send-wrapper ' + className}>
                        <button className={'send-btn '} onClick={onButtonClick} id={benefit.main.id}>
                            {buttonText}
                        </button>
                    </div>
                );
            } else {
                return (
                    <>
                        {showCouponReminderCheckbox && isDesktopOrLaptop && (
                            <div className="coupon-reminder-checkbox">
                                <Checkbox
                                    name="coupon-reminder"
                                    label={ReactHtmlParser(text['coupon_reminder_checkbox_text'] || '', reactParserCommonOptions())}
                                    value={this.state.couponReminderCheckbox}
                                    onChange={(checked) => this.setState({couponReminderCheckbox: checked})}
                                    checked_img={isMobileOrTablet ? getMediaPath(cb_checked_mobile) : getMediaPath(cb_checked)}
                                    not_checked_img={getMediaPath(cb)}
                                    className="coupon-reminder-cb"
                                />
                            </div>
                        )}

                        <div className={'send-wrapper ' + className}>
                            {!isAppOnly && benefit_type === 300 && !isAcquired && !benefit.main.awaitingRestocking && // only type 300 needs and coupon isn't acquired yet the user to input the 4 last cc digits and not awaiting restocking
                                <input type='number' maxLength='4'
                                       placeholder={this.props.text['benefit_page_card_input']}
                                       onInput={this.handleOnInput}/>
                            }

                            {this.isDisplayLink() && // display only if all the conditions of this method are met
                                <Fragment>
                                    <button
                                        className={'send-btn '}
                                        onClick={onButtonClick}
                                        id={benefit.main.id}
                                        style={{
                                            opacity: buttonText === text['out_of_stock_text'] ? 0.5 : 1
                                        }}>

                                        {buttonText}
                                        {hoverMessage && (
                                            <div className="send-btn-hover-message">
                                                {hoverMessage}
                                            </div>
                                        )}
                                    </button>
                                    <span className='err-msg'>{err_msg}</span>
                                </Fragment>
                            }
                        </div>
                    </>);
            }
        }
    }

    isUserLoggedInRequired() {
        let benefitsRequiredUserValidation = this.props.benefitTypesWhatRequireUserValidation; // benefits that needs the user to be logged in - from GD
        const benefit_type = this.props.benefit.main.benefit_type;
        let result = [];
        let res;

        for (let key in benefitsRequiredUserValidation) {
            result.push(benefitsRequiredUserValidation[key]);
        }

        let benefit = result.find(item => item === parseInt(benefit_type));

        res = !!benefit;


        return res;
    }

    handleNavigateToLink = () => {
        const {addPopup, benefit, userData} = this.props;

        const openLink = () => {
            AnalyticsManager.logAddToCart(createAnalyticsItemsList([benefit]));
            AnalyticsManager.logBenefitWebsiteOpen(benefit?.main?.id, benefit?.main?.title);
            window.open(benefit.main.url.route, '_blank');
        };

        if (benefit.main.linkRequiresLogin && !userData) {
            addPopup({
                type: Popups.LOGIN,
                onLogin: openLink,
            });
        } else {
            openLink();
        }
    }

    handleTravelInsurancePopup = () => {
        const {benefit, userData, addPopup} = this.props;

        if (!userData) {
            addPopup({
                type: Popups.LOGIN,
            });
            return;
        }

        if (!userData?.hasAgreedToTravelPopup) {
            addPopup({
                type: Popups.TRAVEL_INSURANCE_POPUP,
                data: benefit.popup,
                onAgreement: this.handleNavigateToLink,
            });
            return;
        }

        this.handleNavigateToLink();
    }

    handleLeadFormClick = () => {
        AnalyticsManager.logClickOLeaveDetails(createAnalyticsItemsList([{
            ...this.props.benefit,
            quantity: 1,
        }]))
        this.setState({leadFormVisible: true});
    };

    isDisplayLink() {
        let url = this.props.benefit.main.url;
        const benefit_type = this.props.benefit.main.benefit_type;

        if (['200', '300', '800', '1000', '1200', '1300'].includes(benefit_type)) {
            return true;
        }

        if (['100', '700', '1100'].includes(benefit_type) && url !== false) {
            return true
        }
    }

    goToLoginPage = () => {
        this.props.addPopup({
            type: Popups.LOGIN,
            onLogin: () => this.getBenefitPageAgain(),
        });
    }

    getBenefitPageAgain = () => {
        this.props.getBenefitById({benefitId: this.props.match.params.id, isCommerce: 0});

    }

    handleOnInput = (e) => {
        if (e.target.value.length > e.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
            this.setState({...this.state, input: {val: e.target.value}});
        } else if (e.target.value.length === e.target.maxLength) {
            this.setState({...this.state, input: {val: e.target.value}});
        } else this.setState({...this.state, input: {val: 0}});
    };

    handleArrowClick = (current) => {
        const type = this.props.benefit.main.images[current].type;
        const url = type === 'image' ? getMediaPath(this.props.benefit.main.images[current].value) : this.props.benefit.main.images[current].value;
        this.setState({selected_img: current, big_screen_url: url, big_screen_type: type});
    };

    getSliderImages = () => {

        const data = this.props.benefit.main.images;

        let res = [];

        data.forEach((item, index) => {

            let src = getMediaPath(item.value);

            //get youtube thumbnail
            if (item.type === 'embedded') {
                if (item.value.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)) {
                    let youtube_video_id = item.value.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
                    if (youtube_video_id.length === 11) {
                        src = "//img.youtube.com/vi/" + youtube_video_id + "/0.jpg";
                    }
                }
            }

            let slideToRender = null;

            switch (item.type) {
                case 'embedded': {
                    if (this.props.deviceState === 'mobile') {
                        slideToRender = <iframe src={item.value} title={item.type + '' + index} referrerPolicy="strict-origin-when-cross-origin"/>;
                    } else {
                        slideToRender = <img src={src} alt={this.props.benefit.main.title}/>;
                    }
                    break;
                }
                case 'image':
                    slideToRender = <img src={src} alt={this.props.benefit.main.title}/>;
                    break;
                default:
                    break;
            }

            const result = {src, component: slideToRender};

            if (item.type === 'embedded') {
                result.iframe = item.value;
            }

            res.push(result);
        });

        return res;
    };

    getBreadCrumbs = () => {
        const data = this.props.benefit.breadcrumbs;

        let res = [];

        data.forEach(item => {
            res.push({
                text: item.title,
                route: getCategoryBreadcrumbRoute({
                    title: item.title,
                    id: item.id,
                }),
            });
        });

        return res;
    };

    isCashBack() {
        const trade_charge_type = this.props.benefit.main.trade_charge_type;// from getDetailedBenefitByIdForWeb
        const tradeBenefitsChargeTypes = this.props.TradeBenefitsChargeTypes;// from generalDeclaration

        return tradeBenefitsChargeTypes[trade_charge_type] === "cashback"

    }

    getDiscountPercents(beforePrice, afterPrice) {
        return Math.abs(afterPrice - beforePrice) / beforePrice * 100;
    }

    render() {
        const {benefit} = this.props;
        const text = this.props.text;
        let benefit_icon = '';
        let benefit_name = '';

        if (benefit === 'error') {
            return <Redirect to={routes.home}/>
        }

        const isDesktopOrLaptop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        let multiBranches = false;
        let is_favorite = false;
        let isActive = true;
        if (benefit) {


            if (parseInt(benefit.main.benefit_type) === 1000) {
                return <Redirect to={routes.home}/>
            }


            isActive = benefit.main.active;

            if (this.props.userData) {
                is_favorite = this.props.userData.favoritesArr.indexOf(this.props.match.params.id) !== -1;
            }

            //checking if not logged user can see thi benefit
            if (this.props.closedBenefitTypes.includes(parseInt(benefit.main.type))) {
                this.props.history.push(routes.home);
                this.props.addPopup({
                        type: Popups.LOGIN,
                    }
                )
            }

            //send button behaviour

            let benefit_type = parseInt(benefit.main.benefit_type);
            benefit_icon = getMediaPath(this.props.iconTypes[benefit_type].imagePath);
            benefit_name = this.props.iconTypes[benefit_type].title;
            multiBranches = Object.keys(benefit.supplierLocations).length > 0;
        }

        let slider_data_brand = {benefits: []}


        if (benefit.hasOwnProperty('relatedBenefitsByBrand')) {
            slider_data_brand = {
                benefits: benefit['relatedBenefitsByBrand'].benefits,
                title: benefit['relatedBenefitsByBrand'].title,
                btnText: benefit['relatedBenefitsByBrand'].btnText
            };
        }

        let slider_data_category = {benefits: []};

        //for bottom slider
        if (benefit.hasOwnProperty('relatedBenefitsBySubCat')) {
            slider_data_category = {
                benefits: benefit['relatedBenefitsBySubCat'].benefits,
                title: benefit['relatedBenefitsBySubCat'].title,
                btnText: benefit['relatedBenefitsBySubCat'].btnText
            };
        }

        const isLead = parseInt(benefit.main?.benefit_type) === 1200;
        const isMultipassBudgetBenefit = parseInt(benefit.main?.multipass_type) === 1;

        const tagImage = this.props.benefit?.main?.coverImagePath ? getMediaPath(this.props.benefit.main.coverImagePath) : '';
        const recommendedBenefits = this.state.recommendedBenefits;
        const recommendedPersonalBenefits = this.state.recommendedPersonalBenefits;
        const showPrices = (!benefit.main?.display_price_members_only) || this.state.isLoggedIn


        return (
            <section className="benefitPage">
                {benefit &&
                    <Fragment>
                        <BreadCrumbs className='bread-benefit' root={{text: 'דף הבית', route: routes.home}}
                                     crumbs={this.getBreadCrumbs()}/>
                        {this.state.preview_link && <div className='preview-link-indicator'>תצוגה מקדימה</div>}
                        <div className='top-banner'>
                            <div className={'gallery-wrapper ' + (benefit.main.images.length > 1 ? 'with-slider' : '')}>
                                <div className="gallery-buttons">
                                    <div className="share-button-wrapper">
                                        {navigator.share && <ShareButton
                                            type={'share'}
                                            iconImage={shareBenefitIcon}
                                            onClick={this.handleShareButtonClick}
                                            isMobile={this.props.deviceState === 'mobile'}
                                            theme={theme}
                                            color={theme?.palette?.text?.primary || '#29286A'}
                                            canShare={!!navigator.share}
                                            compact
                                            tooltipContent={this.props.text?.link_copy_success || 'הקישור הועתק בהצלחה'}
                                            tooltipOpen={this.state.shareToastOpen}
                                            onTooltipClose={() => this.setState({shareToastOpen: false})}
                                            tooltipPlacement="bottom"
                                            testID="benefit-share-button"
                                        />
                                        }
                                    </div>
                                    <FavoriteButton
                                        data={benefit}
                                        state={is_favorite}
                                    />
                                </div>
                                <ImageCarousel
                                    tagImage={tagImage}
                                    imgs={this.getSliderImages()}
                                    className={'gallery-slider'}
                                />

                                {benefit.main.dateExpired && (
                                    <div
                                        className={'count-down ' + (this.state.big_screen_type === 'embedded' ? 'video' : '')}>
                                        <div
                                            className={'timer-wrapper' + (benefit.main.dateExpired === '' ? ' hide-mobile' : '')}>
                                            {benefit.main.dateExpired !== '' &&
                                                <Timer className='benefit-timer' timeSpan={benefit.main.dateExpired}/>
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='discount-wrapper'>
                                <div className='head-title'>
                                    <div className='type-wrap'>
                                        {(benefit_icon !== '') &&
                                            <>
                                                <img src={benefit_icon}
                                                     className="head-img"
                                                     alt=""/>
                                            </>
                                        }
                                        <span className='type-name'>{benefit_name}</span>
                                    </div>
                                    <h1 className='head-span'>{benefit.main.benefit_name}</h1>
                                    <h2 className='description'>
                                        {ReactHtmlParser(benefit.main.description, reactParserCommonOptions())}
                                    </h2>
                                </div>

                                {showPrices ? <div className='prices'>
                                    <span className='data-span'>{text['web_benefit_page_discount']}</span>
                                    {(benefit.main.display_type === 'price_before_and_after' && benefit.main.price_after_discount && benefit.main.price_after_discount !== '') ?
                                        <span
                                            className={'price-span ' + benefit.main.display_type + ' ' + benefit.main.currency}>
                                    {benefit.main.price_after_discount}
                                    </span> : <span
                                            className={'price-span ' + benefit.main.display_type}>{benefit.main.value}</span>}
                                    {(benefit.main.display_type === 'price_and_text') &&
                                        <span
                                            className='free-text'>{benefit.main.small_description ? benefit.main.small_description : ''}</span>
                                    }
                                    {benefit.main.price_before_discount !== undefined &&
                                        benefit.main.price_before_discount !== benefit.main.price_after_discount &&
                                        benefit.main.price_before_discount > 0 &&
                                        <span className={'data-span ' + benefit.main.display_type}>
                                            <span className={'price ' + benefit.main.display_type}>
                                            {getCurrency(benefit.main.currency) + benefit.main.price_before_discount}
                                        </span>
                                    </span>}
                                    <span className='data-span'>{benefit.main.small_text}</span>

                                    {!isDesktopOrLaptop && isActive && this.getButton()}
                                </div> : <div>{text['special_benefit_text_button']} </div>}

                                {this.isCashBack() && !isMultipassBudgetBenefit && benefit.main.displayCashback && (
                                    <div className="cash-back-wrapper">
                                        <p className="cash-back-text">{benefit.main.cashback_description}</p>
                                    </div>
                                )}

                                <div className="extra-info">
                                    {this.getExtraInfo()}
                                </div>


                                {isDesktopOrLaptop && isActive && this.getButton()}

                                {isLead && (
                                    <LeadForm
                                        isVisible={this.state.leadFormVisible}
                                        settings={this.props.benefit.leadsConfig ?? {}}
                                        ref={this.leadFormRef}
                                        benefit={this.props.benefit}
                                    />
                                )}

                            </div>
                        </div>

                        <div className='details-desktop'>
                            {this.getExtraData()}
                        </div>

                        {multiBranches && (
                            <BranchesMap benefit={benefit} branches={benefit.supplierLocations}/>
                        )}


                        <div className='extras' id={CONTAINER_ID.CATEGORY_RECS}>
                            {recommendedBenefits?.benefits?.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSliderNew
                                                       data={recommendedBenefits} isBenefitPageSlider={true}
                                                       className={'benefitsSlider'}/>
                                </div>
                            }
                        </div>




                        <div className='extras' id={CONTAINER_ID.PERSONAL_RECS}>
                            {recommendedPersonalBenefits?.benefits?.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSliderNew data={recommendedPersonalBenefits} isBenefitPageSlider={true}
                                                       className={'benefitsSlider'}/>
                                </div>
                            }

                        </div>


                        <div className='extras'>
                            {slider_data_category.benefits.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSliderNew data={slider_data_category} isBenefitPageSlider={true}
                                                       className={'benefitsSlider'}/>
                                </div>
                            }
                            {slider_data_brand.benefits.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSlider data={slider_data_brand} isBenefitPageSlider={true}
                                                    className={'benefitsSlider'}/>
                                </div>
                            }
                        </div>

                        {!isActive && !this.state.preview_link &&
                            <div className='expired-layer'>
                                <h2>{text['benefit_page_expired_msg']}</h2>
                            </div>
                        }
                    </Fragment>
                }
                {!benefit &&
                    <Loader/>
                }
            </section>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        benefit: store.data.BenefitPage,
        parameters: store.config.Parameters,
        text: store.config.Translations,
        iconTypes: cleanUpObject(store.config.IconTypes),
        benefitStatusDown: store.data.VIPBenefitDown,
        acquired: store.data.BenefitAcquired,
        isMarketingApproved: store.config.isMarketingApproved,
        isConsentsUpdateSuccessful: store.state.isConsentsUpdateSuccessful,
        acquiredErr: store.data.BenefitAcquiredErr,
        purchased: store.data.BenefitPurchased,
        closedBenefitTypes: store.config.ClosedBenefitTypes,
        userData: store.config.UserData,
        availableCoupon: store.data.AvailableCoupon,
        availableCouponErr: store.data.AvailableCouponErr,
        TradeBenefitsChargeTypes: store.config.TradeBenefitsChargeTypes,
        benefitTypesWhatRequireUserValidation: store.config.benefitTypesWhatRequireUserValidation,
        benefitTypes: store.config.BenefitTypes,
        appPopup: store.config.PopTrans.application,
        consentsResponse: store.data.consentsResponse,
        isUpdatedConsents: store.state.isUpdatedConsents,

    }
};

const mapDispatchToProps = dispatch => {
    return {
        resetDynamicLink: () => dispatch(setDynamicLink(false)),
        getBenefitById: (payload) => dispatch(getBenefitById(payload)),
        setBenefitPage: (payload) => dispatch(setBenefitPage(payload)),
        addPopup: (payload) => dispatch(addPopup(payload)),
        removePopup: (payload) => dispatch(removePopup(payload)),
        acquireCoupon: (payload, benefit, translations, onClose) => dispatch(acquireCoupon(payload, benefit, translations, onClose)),
        acquireCouponWeb: (payload) => dispatch(acquireCouponWeb(payload)),
        getAvailableCoupons: (payload) => dispatch(getAvailabaleCoupons(payload)),  //udpates each time this , and then sends this call again on component did update
        setAvailableCoupon: (payload) => dispatch(setAvailableCoupon(payload)),
        setLegalWaiverAgreement: (payload, onSuccess) => dispatch(setLegalWaiverAgreement(payload, onSuccess)),
        setUserLegalWaiverAgreements: (payload) => dispatch(setUserLegalWaiverAgreements(payload)),
        getSelectedBenefits: (payload) => dispatch(searchApi.endpoints.getSelectedBenefits.initiate(payload, {
            skip: false,
        }))
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(BenefitPage);


const getCurrency = (currency) => {
    switch (currency) {
        case 'shekel':
            return '₪';
        case 'dollar':
            return '$';
        case 'euro':
            return '€';
    }
}
